import { useLazyGetBranchesQuery } from '@/api'
import { useContext, useEffect, useState } from 'react'
import { OrganizationContext } from '../../Organization'
import { Box, Button } from '@mui/material'
import { styles } from './styles'
import type { IBranch } from './types'
import { Branch, EditBranch } from './modules'
import { useParams } from 'react-router-dom'
import { useDrawer, useRole } from '@/hooks'
import type { SelectedBranch } from './modules/Branch/types'
import AddIcon from '@mui/icons-material/Add'
import { DrawerType, setCurrentHasBranches } from '@/store/app'
import { useAppDispatch } from '@/store'

export const Branches = () => {
  const { organizationId } = useParams()
  const { user, setHasBranches } = useContext(OrganizationContext)
  const dispatch = useAppDispatch()
  const { hasRole } = useRole()
  const [getBranches, { data: branches }] = useLazyGetBranchesQuery()
  const [selectedBranch, setSelectedBranch] = useState<SelectedBranch>()
  const { showDrawer } = useDrawer()

  const refreshBranch = () => {
    if (
      hasRole('Администратор Тетрон') ||
      (hasRole('Администратор клиента') && (user?.branches ?? []).length === 0)
    ) {
      getBranches({
        companyId: Number(organizationId),
        params: {
          parentIds: 0,
        },
      }).then((response) => {
        dispatch(setCurrentHasBranches(Boolean(response?.data?.length)))
      })
    } else if (user?.branches?.length > 0) {
      getBranches({
        companyId: Number(organizationId),
        params: {
          ids: user?.branches[0],
        },
      })
    }
  }

  useEffect(() => {
    refreshBranch()
  }, [])

  return (
    <Box sx={styles.branches}>
      {branches?.map((branch: IBranch) => (
        <Branch
          branch={branch}
          key={String(branch.id)}
          setSelectedBranch={setSelectedBranch}
          refreshParent={refreshBranch}
        />
      ))}
      <Button
        startIcon={<AddIcon />}
        variant="contained"
        disabled={false}
        onClick={() => {
          setSelectedBranch({
            parent: undefined,
            childs: undefined,
            refresh: refreshBranch,
          })
          showDrawer(DrawerType.EDIT_BRANCH)
        }}
        sx={{
          marginTop: '12px',
          border: 'none',
          '& .MuiButton-startIcon': {
            border: 'none',
          },
        }}
      >
        Добавить филиал
      </Button>
      <EditBranch selectedBranch={selectedBranch} />
    </Box>
  )
}
